<lex-sidenav-container menuWidth="300">
  <ng-container left>
    <div></div>
    <lex-account-search [(selectedAccount)]="selectedAccount" (selectedAccountChange)="selectAccount()" [selectedAccountId]="selectedAccountId" [source]="'manage-billing'"></lex-account-search>
    <div></div>
  </ng-container>

  <!--Manage Billing Main Layout main content-->
  <ng-container right>
    <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch space-between; align-items: stretch; flex: 1 1 0%; gap: 20px;">
      <div></div>
      <div style="flex-direction: row; box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px;">
        <div></div>
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
          <mat-toolbar color="primary" class="toolbar-over-card">
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
              <mat-card-title>Summary </mat-card-title>
            </div>
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center; margin-bottom: 8px;">
              <button mat-icon-button id="displayCurrentMonth" matTooltip="Display Current Month" *ngIf="selectedAccount && hideCurrentMonth" 
                  style="width: 52px; display: flex; justify-content: center; margin-right: -10px;" (click)="toggleCurrentMonth()"><mat-icon class="fa-solid fa-toggle-off" style="width: inherit;"></mat-icon></button>
              <button mat-icon-button id="hideCurrentMonth" matTooltip="Hide Current Month" *ngIf="selectedAccount && !hideCurrentMonth" 
                  style="width: 52px; display: flex; justify-content: center; margin-right: -10px;" (click)="toggleCurrentMonth()"><mat-icon class="fa-regular fa-toggle-on" style="width: inherit;"></mat-icon></button>
              <button mat-icon-button id="exportBilling" matTooltip="Export to Excel" *ngIf="selectedAccount" (click)="exportToExcel()"><mat-icon>file_download</mat-icon></button>
            </div>
          </mat-toolbar>
          <div style="flex: 1 1 0%; box-sizing: border-box;">
            <mat-card appearance="outlined">
              <div style="font-size: 15px" *ngIf="!selectedAccount">
                No Account Selected
              </div>
              <mat-card-content *ngIf="selectedAccount">
                <table mat-table
                       [dataSource]="accountUsage" multiTemplateDataRows>
                  <ng-container matColumnDef="month">
                    <th mat-header-cell *matHeaderCellDef> Month </th>
                    <td mat-cell *matCellDef="let element"> {{element.logMonthString}} </td>
                  </ng-container>

                  <ng-container matColumnDef="empty">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element"> </td>
                  </ng-container>

                  <ng-container matColumnDef="documents">
                    <th class="right-align-cell" mat-header-cell *matHeaderCellDef> Documents </th>
                    <td class="right-align-cell" mat-cell *matCellDef="let element"> {{element.docSize}} </td>
                  </ng-container>

                  <ng-container matColumnDef="productions">
                    <th class="right-align-cell" mat-header-cell *matHeaderCellDef> Productions </th>
                    <td class="right-align-cell" mat-cell *matCellDef="let element"> {{element.productionJobSize}} </td>
                  </ng-container>

                  <ng-container matColumnDef="briefcases">
                    <th class="right-align-cell" mat-header-cell *matHeaderCellDef> Briefcases </th>
                    <td class="right-align-cell" mat-cell *matCellDef="let element"> {{element.downloadSize}} </td>
                  </ng-container>

                  <ng-container matColumnDef="archives">
                    <th class="right-align-cell" mat-header-cell *matHeaderCellDef> Archives </th>
                    <td class="right-align-cell" mat-cell *matCellDef="let element"> {{element.archiveJobSize}} </td>
                  </ng-container>

                  <ng-container matColumnDef="searchIndex">
                    <th class="right-align-cell" mat-header-cell *matHeaderCellDef> Search Index </th>
                    <td class="right-align-cell" mat-cell *matCellDef="let element"> {{element.indexSize}} </td>
                  </ng-container>

                  <ng-container matColumnDef="total">
                    <th class="right-align-cell" mat-header-cell *matHeaderCellDef> Total </th>
                    <td class="right-align-cell" mat-cell *matCellDef="let element"> {{element.totalCaseSize}} </td>
                  </ng-container>

                  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->


                  <ng-container matColumnDef="details">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="8">
                      <div class="table-element-detail"
                           [@detailExpand]="expandedElement.includes(element) ? 'expanded' : 'collapsed'">
                        <div mat-line class="table-element-detail-expanded">
                          <div mat-line>
                            <div class="expanded-detail-header" style="width: 20%"> Case Name </div>
                            <div class="expanded-detail-header right-align-cell" style="width: 8%"> Case Id </div>
                            <div class="expanded-detail-header right-align-cell" style="width: 12.5%"> Documents </div>
                            <div class="expanded-detail-header right-align-cell" style="width: 12.5%"> Productions </div>
                            <div class="expanded-detail-header right-align-cell" style="width: 12.5%"> Briefcases </div>
                            <div class="expanded-detail-header right-align-cell" style="width: 12.5%"> Archives </div>
                            <div class="expanded-detail-header right-align-cell" style="width: 12.5%"> Search Index </div>
                            <div class="expanded-detail-header right-align-cell" style="width: 9.5%"> Total </div>
                          </div>

                          <div *ngFor="let detail of caseUsage">
                            <div class="expanded-detail" style="width: 20%" *ngIf="detail.logMonthString === element.logMonthString">{{detail.caseName}}</div>
                            <div class="expanded-detail right-align-cell" style="width: 8%" *ngIf="detail.logMonthString === element.logMonthString">{{detail.caseId}}</div>
                            <div class="expanded-detail right-align-cell" style="width: 12.5%" *ngIf="detail.logMonthString === element.logMonthString">{{detail.docSize}}</div>
                            <div class="expanded-detail right-align-cell" style="width: 12.5%" *ngIf="detail.logMonthString === element.logMonthString">{{detail.productionJobSize}}</div>
                            <div class="expanded-detail right-align-cell" style="width: 12.5%" *ngIf="detail.logMonthString === element.logMonthString">{{detail.downloadSize}}</div>
                            <div class="expanded-detail right-align-cell" style="width: 12.5%" *ngIf="detail.logMonthString === element.logMonthString">{{detail.archiveJobSize}}</div>
                            <div class="expanded-detail right-align-cell" style="width: 12.5%" *ngIf="detail.logMonthString === element.logMonthString">{{detail.indexSize}}</div>
                            <div class="expanded-detail right-align-cell" style="width: 9.5%" *ngIf="detail.logMonthString === element.logMonthString">{{detail.totalCaseSize}}</div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="summaryColumns"></tr>
                  <tr mat-row *matRowDef="let element; columns: summaryColumns;"
                      [attr.id]="'expandBillingSummary.'+element.logMonthString"
                      class="table-element-row"
                      [class.table-expanded-row]="expandedElement.includes(element)"
                      (click)="setExpandElement(element)">
                  </tr>
                  <tr mat-row *matRowDef="let row; columns: detailColumns" class="table-detail-row"></tr>
                </table>

              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <div></div>
      </div>
      <div></div>
    </div>
  </ng-container>
</lex-sidenav-container>
